module.exports = require("effector");